/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentQueryCategory extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmDocumentQueryCategory");
    }

    getFixupPrototypeFunction() { return AwsSsmDocumentQueryCategory.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentQueryCategory>): AwsSsmDocumentQueryCategory {
        let obj = Object.assign(new AwsSsmDocumentQueryCategory(), model);
        AwsSsmDocumentQueryCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentQueryCategory>): AwsSsmDocumentQueryCategory {
        if (!model) return null;
        return AwsSsmDocumentQueryCategory.newInstance(<AwsSsmDocumentQueryCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentQueryCategory) {
        if (!obj) return;

        models.AwsSsmDocumentQueryCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentQueryCategory): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmDocumentQueryCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Categories for the findings
     */
    categories: Array<string>;

}
